import { render, staticRenderFns } from "./LoginWaitModal.vue?vue&type=template&id=17984915"
import script from "./LoginWaitModal.vue?vue&type=script&lang=js"
export * from "./LoginWaitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports